import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=fa9cc4c2&scoped=true&"
import script from "./Canvas.vue?vue&type=script&lang=js&"
export * from "./Canvas.vue?vue&type=script&lang=js&"
import style0 from "./Canvas.vue?vue&type=style&index=0&id=fa9cc4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9cc4c2",
  null
  
)

export default component.exports